import en from "./En";

const messages = {
  en
};

export default messages;
